/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MediaList_offer$ref: FragmentReference;
declare export opaque type MediaList_offer$fragmentType: MediaList_offer$ref;
export type MediaList_offer = {|
  +products: ?$ReadOnlyArray<?{|
    +id: string,
    +mediaCollection: ?{|
      +name: ?string
    |},
    +price: ?any,
    +type: ?string,
  |}>,
  +voucherCampaign: ?{|
    +banner: ?string,
    +name: ?string,
    +shortText: ?string,
  |},
  +$refType: MediaList_offer$ref,
|};
export type MediaList_offer$data = MediaList_offer;
export type MediaList_offer$key = {
  +$data?: MediaList_offer$data,
  +$fragmentRefs: MediaList_offer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "MediaList_offer",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "products",
      "storageKey": null,
      "args": null,
      "concreteType": "Product",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "mediaCollection",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaCollection",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "price",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "type",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "voucherCampaign",
      "storageKey": null,
      "args": null,
      "concreteType": "VoucherCampaign",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "banner",
          "args": null,
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "shortText",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f11b175e1537b2eeebdd2287e02341fe';

module.exports = node;
